import getStore from 'owa-location-card-v2/lib/data/store';
import { orchestrator } from 'satcheljs';
import { PlaceModel, PlaceType, getPlace } from 'owa-location-service';
import { fetchLocationDetails } from 'owa-location-card-v2/lib/actions/locationCardActions';
import {
    setPlace,
    setIsLoading,
    setIsDataLoaded,
} from 'owa-location-card-v2/lib/mutators/locationCardMutators';
import { trace } from 'owa-trace';
import { PerformanceDatapoint } from 'owa-analytics';

// The perfDataPoint will time out (stop tracking elapsed time inside the panel)
// after 2 minutes.  Note that if not set, the default time out is only 1 minute.
const GETPLACE_TIMEOUT: number = 120000;

/**
 * Fetches the location from the server and updates the store.
 * Before the server call this will set the IsLoading to true. After the server call returns it will update the location
 * in the store with the location from the response if it was found, and sets the isLoading back to false.
 * Before updating the location and in the store and isLoading we need to check if the store is still referencing the same location
 * as the one from the request. This for the case when another card is opened before the previous service call returns.
 */
export default orchestrator(fetchLocationDetails, async actionMessage => {
    const { locationId } = actionMessage;
    let locationDetails: PlaceModel = null;
    let type: PlaceType = 'Unknown';
    let store = getStore();

    setIsLoading(true);

    let perfDatapoint = new PerformanceDatapoint('GETPLACE', { timeout: GETPLACE_TIMEOUT });
    let response = await getPlace(locationId);

    if (response) {
        if (response.status == 200) {
            locationDetails = await response.json();
            type = locationDetails.Type;
        }
    }

    perfDatapoint.addCustomData([
        type,
        (response && response.status) || undefined,
        (response && response.statusText) || undefined,
    ]);
    perfDatapoint.end();

    // if this request is not for the same location as the one in the store then do nothing.
    if (store.place && store.place.Id == locationId) {
        // If the server returned not found then we don't need to update the location in the store, instead we will display the card with the data the client already has
        if (response && response.status == 404) {
            trace.warn(
                'fetchLocationDetails returned NotFound, we use the current location info to display the cards'
            );
        } else if (locationDetails) {
            setPlace(locationDetails);
        }

        setIsLoading(false);
        setIsDataLoaded(true);
    }
});
